/** Keep old catalog prose from adding unintended volume to a saved design. */
export function cleanDesignAttribute(value: string): string {
  return value.replace(
    /A[–-]Line\s*-\s*Fitted down to the belly button,\s*then flares dramatically/gi,
    "A-line - Fitted bodice with a gradually widening skirt"
  );
}

/** Presentation only: retain each distinct requirement and its full wording. */
export function uniqueDesignText(values: string[]): string[] {
  const seen = new Set<string>();
  return values.filter(value => {
    const key = value.trim().replace(/\s+/g, " ").toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

/** A legacy high-low preset must not contradict an explicit floor-clearance requirement. */
export function reconcileHighLowLength(
  length: string | undefined,
  requirements: string[]
): string | undefined {
  if (!length || !/\bhigh[-\s]low\b/i.test(length)) return length;
  const clearance = requirements.find(
    value =>
      /\b(?:hem|skirt|back)\b[^.!?]*\b(?:stays?|remain|kept?)\s+(?:clear\s+of|off)\s+the\s+floor\b/i.test(
        value
      ) &&
      !/\b(?:not|never|don't|doesn't|shouldn't)\s+(?:\w+\s+){0,3}(?:stays?|remain|keep)\b/i.test(
        value
      )
  );
  return clearance && /\bfloor[-\s]length\b/i.test(length)
    ? length.replace(/\bfloor[-\s]length\b/i, "hem, clear of the floor")
    : length;
}
